import { FC } from 'react';
import { HiOutlinePhotograph, HiOutlineCloudUpload } from 'react-icons/hi';

interface ImageUploadProps {
  tourImageHandler: (e: any) => void;
  tourImage: string;
  isPost?: boolean;
}

const ImageUpload: FC<ImageUploadProps> = ({ tourImageHandler, tourImage, isPost = false }) => {
  const TourImageHandler = () => {
    const fileInput = document.getElementById(
      isPost ? 'post_image_input_change' : 'tour_image_input_change',
    ) as HTMLInputElement;
    fileInput.click();
  };

  return (
    <div className='w-full h-full'>
      <div 
        onClick={TourImageHandler}
        className={`
          group relative w-full h-full min-h-[200px] flex flex-col items-center justify-center 
          bg-gray-50 hover:bg-gray-100 dark:bg-gray-900/50 dark:hover:bg-gray-900/80
          border-2 border-dashed border-gray-300 dark:border-gray-700 hover:border-primary-500 dark:hover:border-primary-500
          rounded-xl cursor-pointer transition-all duration-300 overflow-hidden
          shadow-sm hover:shadow-md
        `}
      >
        {tourImage?.length > 0 ? (
          <>
            <img 
              src={tourImage} 
              alt='Cover' 
              className='absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105'
            />
            <div className='absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center text-white backdrop-blur-sm'>
              <HiOutlineCloudUpload className='w-8 h-8 mb-2' />
              <p className='font-medium text-sm'>Change Cover Image</p>
            </div>
          </>
        ) : (
          <div className='flex flex-col items-center justify-center p-6 text-center'>
            <div className='w-16 h-16 bg-white dark:bg-gray-800 rounded-full shadow-sm flex items-center justify-center mb-4 text-primary-500 group-hover:text-primary-600 transition-colors'>
              <HiOutlinePhotograph className='w-8 h-8' />
            </div>
            <p className='text-gray-900 dark:text-white font-medium mb-1'>Upload Cover Image</p>
            <p className='text-sm text-gray-500 dark:text-gray-400'>Click to browse</p>
          </div>
        )}
        
        <input
          type='file'
          hidden
          accept='image/*'
          id={isPost ? 'post_image_input_change' : 'tour_image_input_change'}
          onChange={tourImageHandler}
        />
      </div>
    </div>
  );
};

export default ImageUpload;
